import { LocalDictionaryFactory } from '../../../api/api.module'

import {
    ROUTE_SERVICE_NAME,
    ROUTE_FITTER_SERVICE_NAME,
    ROUTE_POINTS_SERVICE_NAME,
    ROUTE_OPERATORS_SERVICE_NAME,
    RouteService,
    RoutePointService,
    RouteOperatorService,
    RouteFitterService
} from '../../../../services/route'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SYSTEM_SERVICE_NAME, SystemService } from '../../../../services/system'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../../services/user-session'

import { RouteDetailsDirectiveController } from './routes-details.directive.controller'

//#region Asset Imports

import * as TEMPLATE from './routes-details.tpl.html'

//#endregion

// #region Setup

export class RouteDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        'localDictionary',
        ROUTE_SERVICE_NAME,
        ROUTE_FITTER_SERVICE_NAME,
        ROUTE_OPERATORS_SERVICE_NAME,
        ROUTE_POINTS_SERVICE_NAME,
        SYSTEM_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        (
            $scope,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            localDictionary: LocalDictionaryFactory,
            routeService: RouteService,
            routeFitterService: RouteFitterService,
            routeOperatorService: RouteOperatorService,
            routePointsService: RoutePointService,
            systemService: SystemService,
            userSessionService: UserSessionService
        ) => {
            return new RouteDetailsDirectiveController(
                $scope,
                $q,
                $timeout,
                localDictionary,
                routeService,
                routeFitterService,
                routeOperatorService,
                routePointsService,
                systemService,
                userSessionService,
                RouteService.REFERENCE_TYPE,
                RouteService.SIMAX_MODULE_NAME
            )
        }]

    controllerAs = '$ctrl'

    template = TEMPLATE
}

// #endregion
